"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.react_core_config = exports.defaultDateTimeFormatFallback = exports.defaultTimeFormat = exports.defaultDateTimeFormat = exports.defaultDateFormat = void 0;
exports.defaultDateFormat = 'MMMM DD, YYYY';
exports.defaultDateTimeFormat = 'MMMM DD, YYYY, hh:mm A';
exports.defaultTimeFormat = 'hh:mm A';
exports.defaultDateTimeFormatFallback = 'MMMM DD, YYYY, hh:mm A';
var Config = /** @class */ (function () {
    function Config() {
        var _this = this;
        this._internalConfig = {
            pointsFormat: '0,0',
            currencyFormat: '$0,0[.]00',
            currencyFormatWithDecimal: '$0,0.00',
            lotteryTimeZone: undefined,
            maxDateOfBirth: undefined,
            minDateOfBirth: undefined,
            gameType: '',
            instantGameType: 1,
            showGameTypeFilter: false,
            defaultDateFormat: exports.defaultDateFormat,
            defaultDateTimeFormat: exports.defaultDateTimeFormat,
            defaultTimeFormat: exports.defaultTimeFormat,
            defaultDateTimeFormatFallback: exports.defaultDateTimeFormatFallback,
            addressBaseUrl: '',
            promoEndingSoonDays: undefined,
            arcadeGameType: undefined,
            lotteryId: 49
        };
        this.defaultDateTimeFormatFallback = function () {
            return !!_this.internalConfig.defaultDateTimeFormatFallback ? _this.internalConfig.defaultDateTimeFormatFallback : exports.defaultDateTimeFormatFallback;
        };
        this.defaultDateFormat = function () {
            return !!_this.internalConfig.defaultDateFormat ? _this.internalConfig.defaultDateFormat : exports.defaultDateFormat;
        };
        this.defaultDateTimeFormat = function () {
            return !!_this.internalConfig.defaultDateTimeFormat ? _this.internalConfig.defaultDateTimeFormat : exports.defaultDateTimeFormat;
        };
        this.defaultTimeFormat = function () {
            return !!_this.internalConfig.defaultTimeFormat ? _this.internalConfig.defaultTimeFormat : exports.defaultTimeFormat;
        };
    }
    Object.defineProperty(Config.prototype, "internalConfig", {
        get: function () {
            return this._internalConfig;
        },
        set: function (value) {
            this._internalConfig = __assign(__assign({}, this._internalConfig), value);
        },
        enumerable: false,
        configurable: true
    });
    Config.prototype.setInternalConfig = function (value) {
        this._internalConfig = __assign(__assign({}, this._internalConfig), value);
    };
    return Config;
}());
var react_core_config = new Config();
exports.react_core_config = react_core_config;
//# sourceMappingURL=config.js.map